import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import PageHeader from '../PageHeader';
import NotificationsPanel from '../../NotificationsPanel';
// import Dashboard from '@/pages/admin/Dashboard';
import Organizations from '@/pages/admin/Organizations/Organizations';
import Forms from '@/pages/admin/Forms/Forms';
import OrganizationDetails from '@/pages/admin/Organizations/OrganizationDetails';
import FormDetails from '../../../pages/admin/Forms/FormDetails';
import AddQuestion from '../../../pages/admin/Forms/AddQuestion';
import QuestionDetails from '../../../pages/admin/Forms/QuestionDetails';
import Campaigns from '../../Campaigns/Campaigns';
import CampaignDetails from '../../Campaigns/CampaignDetails';
import Interpreter from '../../../pages/admin/Interpreter/Interpreter';
import ManageAssignments from '../../../pages/admin/Interpreter/ManageAssignments';
import Dashboard from '../../../pages/Interpreter/Dashboard';

const { Content } = Layout;

const InterpretersLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [notificationsVisible, setNotificationsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width <= 768;
      setIsMobile(mobile);
      
      // Only show toggle on mobile
      setShowToggle(mobile);
      
      // Auto-collapse on mobile, but maintain user preference on desktop
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); 
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    if (isMobile) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        notificationsVisible={notificationsVisible}
        setNotificationsVisible={setNotificationsVisible}
        isMobile={isMobile}
        handleToggle={handleToggle}
      />
      <NotificationsPanel
        visible={notificationsVisible}
        onClose={() => setNotificationsVisible(false)}
      />
      <Layout>
        <PageHeader
          collapsed={collapsed}
          setCollapsed={handleToggle}
          isMobile={isMobile}
          showToggle={showToggle}
        />
        <Content className="px-5 pb-5 md:p-6 pt-0 bg-white h-[80vh] overflow-y-scroll hide-scrollbar">
          <Routes>
            <Route path="/" element={<Navigate to="/interpreter/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="organisations" element={<Organizations />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="campaigns/:id" element={<CampaignDetails />} />
            <Route path="forms" element={<Forms />} />
            {/* <Route path="interpreter" element={<Interpreter />} /> */}
            <Route path="assignments" element={<ManageAssignments />} />
            
            <Route path="organisations/:id" element={<OrganizationDetails />} />
            <Route path="forms/:id" element={<FormDetails />} />
            <Route path="forms/:formId/questions/add" element={<AddQuestion mode="add" />} />
            <Route path="forms/:formId/questions/edit/:questionId" element={<AddQuestion mode="edit" />} />
            <Route path="forms/:formId/questions/details/:questionId" element={<QuestionDetails />} />
            <Route path="*" element={<Navigate to="/interpreter/dashboard" replace />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default InterpretersLayout;
